module.exports = __webpack_public_path__ + "admin/assets/proconlogo-h21.7f7f8a6.svg";